let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2oAxu")).then(() => parcelRequire('5SMTp'));